module.exports = __webpack_public_path__ + "img/10.856d13d0.jpg";